<template>
  <button :disabled="isProcessing" @click="handlePayment">
    {{ isProcessing ? 'Processando...' : 'Finalizar Compra' }}
  </button>
</template>

<script setup lang="ts">
import { useCheckoutValidation } from '@/composables/useCheckoutValidation';
import { useRouter } from 'vue-router';

const router = useRouter();

// 1. Inclua o isProcessing aqui na desestruturação
const { form, errors, isProcessing, validateForm } = useCheckoutValidation();

const handlePayment = async () => {
  // 2. Valida primeiro
  if (!validateForm()) return;

  // 3. Ativa o estado de processamento
  isProcessing.value = true;

  try {
    // Simula uma chamada de API de 2 segundos
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // Sucesso!
    router.push({ name: 'success' });
  } catch (error) {
    alert("Erro ao processar pagamento");
  } finally {
    // 4. Desativa o loading independente de dar erro ou sucesso
    isProcessing.value = false;
  }
};
</script>

